import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full font-label mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Explore Our <span className="text-primary-500">Spreadsheet</span> Categories
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-xl mx-auto">
            Browse through our carefully curated category spreadsheets — every link takes you directly to verified product lists on Kaspreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => handleClick(cat.url)}
              className="group relative bg-white rounded-xl overflow-hidden hover:scale-[1.03] transition-transform duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="text-white text-xs md:text-sm font-semibold font-label drop-shadow-sm">
                  {cat.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}